var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CPCheckboxAccordion',[_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-5 pb-2 border-bottom"},[_vm._v("Source")]),_c('div',{staticClass:"col-4 pb-2 border-bottom"},[_vm._v("Additional information")]),_c('div',{staticClass:"col-3 pb-2 border-bottom"},[_vm._v("Remarks")])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }